import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSocialIconLinkComponent } from "./social-icon-link-component.scss";
class SocialIconLinkComponent extends PureComponent {
    render() {
        const { icon: Icon, color } = this.props;
        return /*#__PURE__*/ _jsx(StyledSocialIconLinkComponent, {
            className: "social-icon-link-component",
            children: /*#__PURE__*/ _jsx(Icon, {
                className: "social-icon",
                style: {
                    fill: color
                }
            })
        });
    }
}
export { SocialIconLinkComponent as default };
